import { ActivityLogAuthor } from '../models/activty-log.model';
import { TeamMemberModel } from '../models/user.model';

export const UNKNOWN_USER = 'Unknown user';

/** Activity rows store the author's full_name as user_name; fall back to their email, then a placeholder. */
export const resolveAuditUser = (
    userId: number | null | undefined,
    userName: string | null | undefined,
    membersById: Map<number, TeamMemberModel>,
): string => {
    if (userName && userName.trim()) return userName;
    const member = userId != null ? membersById.get(userId) : undefined;
    return member?.email || UNKNOWN_USER;
};

/** How a team member is labelled in audit filters, so options read the same as entries. */
export const memberDisplayName = (member: TeamMemberModel): string =>
    member.full_name && member.full_name.trim()
        ? member.full_name
        : member.email || UNKNOWN_USER;

export const memberOptions = (
    members: TeamMemberModel[],
): { label: string; value: number }[] =>
    members.map((m) => ({ label: memberDisplayName(m), value: m.id }));

/** Filter options from everyone who made changes: name, then email, then id. */
export const authorOptions = (
    authors: ActivityLogAuthor[],
): { label: string; value: number }[] =>
    authors.map((a) => ({
        label:
            (a.user_name && a.user_name.trim()) ||
            a.email ||
            `User #${a.user_id}`,
        value: a.user_id,
    }));
